import EnrolmentChart from "./EnrolmentChart";

export default EnrolmentChart;